export const extractError = error => {
  if (typeof error === "string") {
    return error;
  }

  return (error && error.error && error.error.message.trim()) || error?.message?.trim();
};
